import { useState } from 'react';
import { useAuthStore } from '../store/authStore';
import { apiLogin } from '../api/auth.api';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';

export function LoginPage() {
  const setAuth = useAuthStore((s) => s.setAuth);
  const [login, setLogin] = useState('');
  const [password, setPassword] = useState('');
  const [err, setErr] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  const submit = async (e: React.FormEvent): Promise<void> => {
    e.preventDefault();
    setErr(null);
    setBusy(true);
    try {
      const { token, login: l } = await apiLogin(login, password);
      setAuth(token, l);
    } catch {
      setErr('Неверный логин или пароль');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100">
      <form
        onSubmit={submit}
        className="w-full max-w-sm bg-white rounded-2xl shadow-md p-8 flex flex-col gap-4"
      >
        <h1 className="text-2xl font-bold text-center mb-2">EDO</h1>
        <Input
          label="Логин"
          value={login}
          onChange={(e) => setLogin(e.target.value)}
          autoFocus
        />
        <Input
          label="Пароль"
          type="password"
          value={password}
          onChange={(e) => setPassword(e.target.value)}
        />
        {err && <p className="text-sm text-red-600">{err}</p>}
        <Button type="submit" disabled={busy || !login || !password}>
          {busy ? 'Вход…' : 'Войти'}
        </Button>
      </form>
    </div>
  );
}
